import { Component, OnInit } from '@angular/core';
import { MdDialogRef } from '@angular/material';
import { InventoryService } from '../../../agatextscreens/inventory/inventory.service';
import { TdDialogService } from '@covalent/core';
import { Piece } from '../../../agatextscreens/inventory/piece';
import { Product } from '../../../agatextscreens/purchasing/products/product';
import { PrintingService } from '../../services/printing.service';
import { ProductService } from '../../../agatextscreens/purchasing/products/product.service';
import { AuthenticationService } from '../../services/authentication.service';

@Component({
  selector: 'app-inline-cut',
  templateUrl: './inline-cut.component.html',
  styleUrls: ['./inline-cut.component.scss'],
  providers: [InventoryService, PrintingService, ProductService]
})
export class InlineCutComponent implements OnInit {
  pieceNumber: string;

  newPieceNumber: string;

  fullLength: number;
  newLength: number;

  constructor(private _ref: MdDialogRef<InlineCutComponent>,
    private _inventoryService: InventoryService,
    private _printingService: PrintingService,
    private _authService: AuthenticationService,
    private _productService: ProductService,
    private _dialogService: TdDialogService) { }

  ngOnInit() {
    this._inventoryService.suggestNextNumber(this.pieceNumber).subscribe(
      response => {
        this.newPieceNumber = response.number;
      }
    );
  }

  cutItem() {
    this._inventoryService.cutPiece(this.pieceNumber, this.newPieceNumber, this.fullLength - this.newLength, this.newLength).subscribe(
      response => {
        if (response.status == 'SUCCESS') {
          this._dialogService.openConfirm({
            message: 'Item has been cut! Do you want to print new labels for both pieces?',
            title: 'Success'
          }).afterClosed().subscribe(
            r => {
              if (r) {
                // Wants to print. Print both labels
                [this.pieceNumber, this.newPieceNumber].forEach(
                  (piece_no: string) => {
                    this._inventoryService.getPieceByPieceNumber(piece_no).subscribe(
                      response => {
                        this.printRollLabel(response.id);
                      }
                    );
                  });
              }

              this._ref.close(true);

            }
          );
          // ^ If it worked go back to the main screen
        } else {
          if (response.error.startsWith('Duplicate entry')) {
            this._dialogService.openAlert({
              message: 'The selected piece number already exists. Please use a different one',
              title: 'Error'
            });

          } else {
            this._dialogService.openAlert({
              message: 'Could not save new lengths!',
              title: 'Error'
            });
          }

          this._ref.close(false);
        }
      }
    );
  }

  printRollLabel(piece_id: number) {
    this._inventoryService.getPiece(piece_id, false).subscribe(
      (response: Piece[]) => {
        if (Array.isArray(response) && response.length > 0) {
          let piece = response[0];

          // Fill in the gaps from the product view
          this._productService.getOneProduct(piece.color_id + '').subscribe(
            (product: Product) => {
              if (product != null) {
                this._printingService.print(
                  {
                    company_name: 'Mystic', // Set in stone
                    collection: piece.collection_name,
                    design: piece.design_name,
                    part_number: piece.piece_number,
                    color: piece.color_name,
                    grade_cut: '',
                    lot_no: piece.lot_number,
                    meters: piece.length,
                    kilos: piece.weight,
                    composition: product.composition,
                    width: product.width,
                    weight: product.weight_gsm
                  }, this._authService.getPrinterId(), 1, 'roll').subscribe(
                    response => {
                      if (response['status'] == 'SUCCESS') {
                        this._dialogService.openAlert({
                          message: 'Sent to print queue!',
                          title: 'Success'
                        });
                      } else {
                        this._dialogService.openAlert({
                          message: 'Could not send to print queue!',
                          title: 'Failed'
                        });
                      }
                    }
                  );
              } else {
                this._dialogService.openAlert({
                  message: 'The product information could not be retrieved!',
                  title: 'Failed'
                });
              }
            }
          );
        } else {
          this._dialogService.openAlert({
            message: 'The roll information could not be found!',
            title: 'Failed'
          });
        }
      });
  }

  close() {
    this._ref.close(false);
  }
}



// WEBPACK FOOTER //
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/src/app/shared/dialogs/inline-cut/inline-cut.component.ts